import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useEffect } from 'react'

/**
 * Hook para gerenciar o fluxo completo de autenticação e callbacks
 */
export function useAuthFlow() {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const { isAuthenticated, isLoading: authLoading } = useAuth()
  
  const callbackUrl = searchParams.get('callback')

  const isLoading = authLoading

  const getRedirectUrl = () => {
    // Se não está autenticado, vai para login
    if (!isAuthenticated) {
      return '/'
    }

    // Se está autenticado
    if (isAuthenticated) {
      // Se há callback URL, usa ela
      if (callbackUrl) {
        return decodeURIComponent(callbackUrl)
      }
      // Senão, vai para a página inicial
      return '/'
    }

    // Estado ainda carregando
    return null
  }

  const navigateToCorrectPage = () => {
    const redirectUrl = getRedirectUrl()
    if (redirectUrl) {
      navigate(redirectUrl)
    }
  }

  return {
    isAuthenticated,
    isLoading,
    callbackUrl,
    getRedirectUrl,
    navigateToCorrectPage
  }
}
